import { ref } from 'vue'
import { useSSO } from './sso'
import { sendOtp } from '@/use/signup'
import { ERROR, SUCCESS } from '@/constants/icons'
import { useToasts } from './toasts'
const RESET_OTP_TIME = 30
const timerCount = ref<any>(RESET_OTP_TIME)
const timerEnable = ref<any>(false)
const { showLoader } = useSSO()
const { addToast } = useToasts()
let timerInterval: any = null

export const useOTP = () => {
  const startTimer = () => {
    timerCount.value = 30
    timerEnable.value = true
    timerInterval = setInterval(() => {
      if (timerCount.value > 0) {
        timerCount.value = timerCount.value - 1
      } else {
        resetTimer()
      }
    }, 1000)
  }

  const resetTimer = () => {
    timerEnable.value = false
    timerCount.value = RESET_OTP_TIME
    clearInterval(timerInterval)
  }

  const sendAuthenticationCode = async (
    token: any,
    inputData: any,
    isResend: boolean,
    otpFor: string,
    name = ''
  ) => {
    let response = null
    if (inputData?.inputValue !== '') {
      showLoader(true)
      response = await sendOtp({
        type: inputData?.inputType === 'phone' ? 'phone_number' : 'email',
        value: inputData?.inputValue,
        name,
        otpFor,
        recaptchaToken: token
      }).then((r: any) => {
        if (r && r.success) {
          startTimer()
        }
        return r
      })

      showLoader(false)
      const error = response?.data?.error
      if (!isResend) {
        if (error) {
          addToast({
            timeout: 5000,
            color: 'error',
            prependIcon: ERROR,
            message: 'Something went wrong, please try again later.'
          })
        }
      } else {
        if (error) {
          addToast({
            timeout: 5000,
            color: 'error',
            prependIcon: ERROR,
            message: 'Unable to send OTP code.'
          })
        } else {
          addToast({
            timeout: 5000,
            color: 'success',
            prependIcon: SUCCESS,
            message: 'OTP has been sent.'
          })
        }
      }
      return response
    }
  }

  return {
    startTimer,
    resetTimer,
    timerCount,
    timerEnable,
    sendAuthenticationCode
  }
}
